import * as qs from 'query-string';
import { location } from '@atlassian/help-center-common-util/location';

export function retrieveUrlParams() {
    const searchParams = location().search;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedSearchQuery = qs.parse(searchParams);
    return {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        appUserId: numberOrUndefined(parsedSearchQuery.appUserId),
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        username: parsedSearchQuery.username,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        token: parsedSearchQuery.token,
    };
}

function numberOrUndefined(potentialNumber: string) {
    if (!potentialNumber) {
        return undefined;
    }

    const asInt = parseInt(potentialNumber, 10);
    if (isNaN(asInt)) {
        return undefined;
    }

    return asInt;
}
